import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useFamilyStore } from './stores/familyStore';
import CodeEntry from './components/CodeEntry';
import FamilyDashboard from './pages/FamilyDashboard';

const App: React.FC = () => {
  const { isAuthenticated } = useFamilyStore();

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rota principal - redireciona baseado na autenticação */}
          <Route 
            path="/" 
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <CodeEntry />
            } 
          />
          
          {/* Rota do dashboard - protegida por autenticação */}
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? <FamilyDashboard /> : <Navigate to="/" replace />
            } 
          />
          
          {/* Rota de fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;

